import React from 'react';
import PropTypes from 'prop-types';

const BoxIcon = ({ className, size = 'md' }) => {
  const sizes = {
    sm: { width: '12', height: '13.39' },
    md: { width: '20', height: '22' },
  };

  return (
    <svg
      width={sizes[size].width}
      height={sizes[size].height}
      viewBox='0 0 20 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        className={className}
        d='M1.27 5.96002L10 11.01L18.73 5.96002M10 21.08V11M19 15V7.00002C18.9996 6.6493 18.9071 6.30483 18.7315 6.00119C18.556 5.69754 18.3037 5.44539 18 5.27002L11 1.27002C10.696 1.09449 10.3511 1.00208 10 1.00208C9.64893 1.00208 9.30404 1.09449 9 1.27002L2 5.27002C1.69626 5.44539 1.44398 5.69754 1.26846 6.00119C1.09294 6.30483 1.00036 6.6493 1 7.00002V15C1.00036 15.3508 1.09294 15.6952 1.26846 15.9989C1.44398 16.3025 1.69626 16.5547 2 16.73L9 20.73C9.30404 20.9056 9.64893 20.998 10 20.998C10.3511 20.998 10.696 20.9056 11 20.73L18 16.73C18.3037 16.5547 18.556 16.3025 18.7315 15.9989C18.9071 15.6952 18.9996 15.3508 19 15Z'
        stroke='#242546'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

BoxIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default BoxIcon;
